import { getBaseUrl, handleError, handleResponse } from "./apiUtils";

const baseUrl = getBaseUrl();

export async function addWorkableHoliday(name, date) {
  const holiday = {
    holidayName: name,
    holidayDate: date
  };

  return await fetch(`${baseUrl}/Holiday/AddWorkableHoliday`, {
    method: 'POST',
    headers: { "content-type": "application/json" },
    body: JSON.stringify(holiday)
  })
  .then(handleResponse)
  .catch(handleError);
}

export async function getWorkableHolidays(year) {
  return await fetch(`${baseUrl}/Holiday/GetWorkableHolidays?year=${year}`).then(handleResponse).catch(handleError);
}

export async function deleteWorkableHoliday(name, date) {
  return await fetch(`${baseUrl}/Holiday/RemoveWorkableHoliday?holidayName=${name}&holidayDate=${date}`,
    {
      method: 'DELETE'
    }
  ).then(handleResponse)
  .catch(handleError);
}